<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thông tin tag</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col>
                                <b-form-group label="Mã tag:"
                                              label-for="code"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right"
                                              :label-class="editing ? 'required' : ''">
                                    <b-form-input type="text" id="code"
                                                  class="col-6"
                                                  v-if="editing"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.tag.code.$model"
                                                  :state="$v.tag.code.$dirty? !$v.tag.code.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback">
                                        Vui lòng nhập mã tag
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label col-6 " v-if="!editing">{{ tag.code }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Tên tag:"
                                              label-for="name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right"
                                              :label-class="editing ? 'required' : ''">
                                    <b-form-input type="text" id="name"
                                                  class="col-6"
                                                  v-if="editing"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.tag.name.$model"
                                                  :state="$v.tag.name.$dirty? !$v.tag.name.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback">
                                        Vui lòng nhập tên tag
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label col-6 " v-if="!editing">{{ tag.name }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        
                        <b-row>
                            <b-col>
                                <b-form-group label="" :label-cols="4">
                                    <!--<b-button type="button" variant="primary" @click="edit" v-if="!editing ">Sửa</b-button>-->
                                    <b-button type="button" variant="secondary" @click="back" v-if="!editing">Quay lại</b-button>
                                    <b-button  type="submit" variant="primary" v-if="editing && authorize(['ManageTag'])">Ghi lại</b-button>
                                    <b-button type="button" variant="secondary" @click="cancel" v-if="editing">Hủy</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { required, minLength, maxLength, } from 'vuelidate/lib/validators'
    import { authorizationMixin } from '@/shared/mixins'

    export default {
        name: 'tagDetail',
        mixins: [validationMixin, authorizationMixin],
        data() {
            return {
                tag: {},
                editing: this.$route.meta.editing,
            }
        },
        computed: {
            tagId() {
                return this.$route.params.tagId;
            },
        },
        validations: {
            tag: {
                name: {
                    required,
                    maxLength: maxLength(256)
                },
                code: {
                    required,
                    maxLength: maxLength(256)
                },
            },
        },
        watch: {
            //'unitType.code'(newVal) {
            //    this.checkExistCode(newVal);
            //}
        },
        created() {
            this.loadtagDetail();
        },
        methods: {
            loadtagDetail() {
                var vm = this;
                return this.$services.get(`master-data/tags/${this.tagId}`).done(tag => {
                    vm.tag = tag;
                });
            },
            edit() {
                this.editing = true;
            },
            back() {
                this.$router.push({ path: '/master-data/tags' });
            },
            cancel() {
                var vm = this;
                this.loadtagDetail().done(() => vm.editing = false);
            },
            save() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    var vm = this;
                    this.$services.put(`master-data/tags/${this.tagId}`, this.tag).done(() => {
                        vm.$toastr.s('Cập nhật tag thành công');
                        vm.cancel();
                    });
                }
            },
            checkExistCode(newVal) {
                if (newVal) {
                    //var vm = this;
                    //this.$services.get(`master-data/existing-unit-types-code/${newVal}/${this.unitType.id || null}`).done(returnData => {
                    //    if (!returnData) {
                    //        this.codeUnique = "required";
                    //    }
                    //    else {
                    //        this.codeUnique = "";
                    //    }
                    //});
                }
                else {
                    this.codeUnique = "required";
                }
            }
        }
    }
</script>
<style scoped>
</style>
